import { getService } from '#root/store';

export const useTrans = () => {
  const { translateKey, list } = getService('translation');
  return { t: translateKey, l: list };
};

export const useTranslation = () => {
  return getService('translation').translateKey;
};
